// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"a585706d432a17cf","6350":"eb7186aacc1dd047","7856":"fde382366c7f2aef"}[chunkId] + ".js";
};